import React, { useEffect, useState } from "react";
import MostrarCotizacion from "./MostrarCotizacion";
import API from "../api";
import "./buscarCotizaciones.css"; // 👉 nuevo CSS

function BuscarCotizaciones() {
  const [cotizaciones, setCotizaciones] = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    fetch(`${API}/cotizaciones`)
      .then((res) => res.json())
      .then((data) => setCotizaciones(data))
      .catch((error) => console.error("Error al obtener cotizaciones:", error));
  }, []);

  const eliminarCotizacion = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta cotización?")) return;

    try {
      const res = await fetch(`${API}/cotizaciones/${id}`, { method: "DELETE" });

      if (res.ok) {
        setCotizaciones((prev) => prev.filter((c) => c._id !== id));
        alert("✅ Cotización eliminada.");
        if (seleccionada?._id === id) setSeleccionada(null);
      } else {
        alert("❌ Error al eliminar.");
      }
    } catch (error) {
      alert("❌ Error al eliminar: " + error.message);
    }
  };

  const imprimir = () => {
    if (!seleccionada) return;
    window.print();
  };

  const filtradas = cotizaciones.filter((c) =>
    [c.numero, c.cliente, c.producto].some((campo) =>
      campo?.toString().toLowerCase().includes(busqueda.toLowerCase())
    )
  );

  return (
    <div className="buscar-cotizaciones-container">
      <h2 className="titulo-busqueda">📄 Buscar Cotizaciones</h2>

     <div className="busqueda-facturas-wrapper">
  <input
    type="text"
    placeholder="🔎 Buscar por número, cliente o producto..."
    value={busqueda}
    onChange={(e) => setBusqueda(e.target.value)}
    className="input-busqueda-facturas"
  />
</div>


      {filtradas.length === 0 ? (
        <p>No hay cotizaciones coincidentes.</p>
      ) : (
        <div className="tabla-container">
          <table className="tabla-cotizaciones">
            <thead>
              <tr>
                <th>N°</th>
                <th>Cliente</th>
                <th>Producto</th>
                <th>Fecha</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {filtradas.map((coti, i) => (
                <tr key={i}>
                  <td>{coti.numero}</td>
                  <td>{coti.cliente}</td>
                  <td>{coti.producto}</td>
                  <td>{new Date(coti.fecha).toLocaleDateString("es-CL")}</td>
                 <td>
  <button className="btn-ver-lindo" onClick={() => setSeleccionada(coti)}>
    <span className="text">Ver</span>
  </button>

 <button className="btn-eliminar-lindo" onClick={() => eliminarCotizacion(coti._id)}>
  <span>Eliminar</span>
</button>

</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {seleccionada && (
        <div className="detalle-cotizacion">
          <h4>📝 Detalle Cotización N° {seleccionada.numero}</h4>
          <div className="cotizacion-wrapper">
            <MostrarCotizacion datos={seleccionada} />
          </div>
          <div className="botones-cierre">
            <button onClick={() => setSeleccionada(null)} className="btn-cerrar-lindo">
  <span className="text">❌ Cerrar</span>
</button>

          </div>
        </div>
      )}
    </div>
  );
}

export default BuscarCotizaciones;
